<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.TroubleshootTermination.Header' | translate:'Why not terminated?' }}">
    <div *ngIf="!isLoading">
    <div class="checklist-container">
      <div class="icon-container">
        <mat-icon *ngIf="checklist && checklist.TerminationCreated" class="checklist-icon green">check_circle</mat-icon>
        <mat-icon *ngIf="checklist && !checklist.TerminationCreated" class="checklist-icon red">cancel</mat-icon>
      </div>
      <div class="checklist-name">{{ 'Turbo.TroubleshootTermination.TerminationCreated' | translate:'Termination created?' }}</div>
    </div>
    <div class="dots-container">
      <div class="dot"></div>
    </div>
    <div class="checklist-container">
      <div class="icon-container">
        <mat-icon *ngIf="checklist && checklist.ActionDate" class="checklist-icon green">check_circle</mat-icon>
        <mat-icon *ngIf="checklist && !checklist.ActionDate" class="checklist-icon red">cancel</mat-icon>
      </div>
      <div class="checklist-name">{{ 'Turbo.TroubleshootTermination.ActionDate' | translate:'Action date passed?' }}</div>
    </div>
    <div class="dots-container">
      <div class="dot"></div>
    </div>
    <div class="checklist-container">
      <div class="icon-container">
        <mat-icon *ngIf="checklist && checklist.IntegrationErrorNotExists" class="checklist-icon green">check_circle</mat-icon>
        <mat-icon *ngIf="checklist && !checklist.IntegrationErrorNotExists" class="checklist-icon red">cancel</mat-icon>
      </div>
      <div class="checklist-name">{{ 'Turbo.TroubleshootTermination.IntegrationErrorNotExists' | translate:'No integration errors exist?' }}</div>
    </div>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate" style="margin-left: -15px; position: absolute; width: calc(100% + 30px); top: 0px;"></mat-progress-bar>
  </t4-container>
</mat-dialog-content>

